if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        // Keep the reused zoom slider aligned after hidden/visible transitions.
        zoomRequest: 0,
        zoomTimer: null,
        zoomPosition: null,
        zoomUsesSplide: false,
        zoomReadyHandler: null,
        zoomInteractionHandler: null,
        zoomInteractionModal: null,
        zoomUserInteracted: false,
        zoomScrolledRequest: 0,
        init() {
          this.zoomReadyHandler = () => this._scheduleZoomPosition();
          document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, this.zoomReadyHandler);
        },
        destroy() {
          this.zoomRequest++;
          clearTimeout(this.zoomTimer);
          this._removeZoomInteraction();
          document.removeEventListener(`eurus:zoom-image-ready:${settings.section_id}`, this.zoomReadyHandler);
        },
        _removeZoomInteraction() {
          this.zoomInteractionModal?.removeEventListener('pointerdown', this.zoomInteractionHandler, true);
          this.zoomInteractionModal?.removeEventListener('click', this.zoomInteractionHandler, true);
          this.zoomInteractionModal?.removeEventListener('keydown', this.zoomInteractionHandler, true);
          this.zoomInteractionModal?.removeEventListener('wheel', this.zoomInteractionHandler, true);
          this.zoomInteractionModal = null;
        },
        _positionZoom(request) {
          if (!this.zoomIsOpen || this.zoomUserInteracted || request !== this.zoomRequest) return;
          const modal = document.getElementById(`ProductModal-${settings.section_id}`);
          if (!modal || !modal.getClientRects().length || modal.getBoundingClientRect().width === 0) return;
          if (!this.zoomUsesSplide) {
            if (this.zoomScrolledRequest === request) return;
            const image = document.getElementById(this.zoomPosition + '-image-zoom-' + settings.section_id);
            if (image) {
              image.scrollIntoView({ behavior: 'smooth', block: 'start' });
              this.zoomScrolledRequest = request;
            }
            return;
          }
          const gallery = document.getElementById(`media-gallery-${settings.section_id}`);
          const slider = gallery?.splide;
          if (!slider || slider.state.is(7)) return;
          const slides = slider.Components.Slides.get();
          const selected = slides.find(item => item.slide.getAttribute('x-slide-index') == this.zoomPosition);
          if (!selected) return;
          // Recalculate geometry while visible, even when the logical index is unchanged.
          // Avoid refresh(): the theme's refresh hook adds duplicate thumbnail handlers.
          slider.Components.Move.cancel();
          slider.Components.Scroll.cancel();
          slider.state.set(3);
          slider.Components.Layout.resize(true);
          slider.Components.Controller.go(selected.index, true);
        },
        _scheduleZoomPosition() {
          if (!this.zoomIsOpen) return;
          const request = this.zoomRequest;
          this.$nextTick(() => requestAnimationFrame(() => requestAnimationFrame(() => this._positionZoom(request))));
        },
        zoomOpen(position, isSplide) {
          this.zoomRequest++;
          clearTimeout(this.zoomTimer);
          this._removeZoomInteraction();
          this.zoomUserInteracted = false;
          this.zoomInteractionModal = document.getElementById(`ProductModal-${settings.section_id}`);
          this.zoomInteractionHandler = () => {
            this.zoomUserInteracted = true;
            clearTimeout(this.zoomTimer);
          };
          this.zoomInteractionModal?.addEventListener('pointerdown', this.zoomInteractionHandler, true);
          this.zoomInteractionModal?.addEventListener('click', this.zoomInteractionHandler, true);
          this.zoomInteractionModal?.addEventListener('keydown', this.zoomInteractionHandler, true);
          this.zoomInteractionModal?.addEventListener('wheel', this.zoomInteractionHandler, { capture: true, passive: true });
          this.zoomPosition = position;
          this.zoomUsesSplide = isSplide;
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          this._scheduleZoomPosition();
          // A final alignment follows the existing 500ms modal entrance transition.
          const request = this.zoomRequest;
          this.zoomTimer = setTimeout(() => this._positionZoom(request), 550);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomRequest++;
          clearTimeout(this.zoomTimer);
          this._removeZoomInteraction();
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },

        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}